module.exports = "/../../dist/frontend/images/tutos.webp?7762408febb5ea65aaa71022be112188";